import { render, staticRenderFns } from "./NidCheck.vue?vue&type=template&id=730b76d3&scoped=true&"
import script from "./NidCheck.vue?vue&type=script&lang=js&"
export * from "./NidCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730b76d3",
  null
  
)

export default component.exports